<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fas fa-project-diagram"></i> Utasítások</h1>
			</div>
			<div class="ms-auto">
				<button class="btn btn-success btn-rounded px-4 rounded-pill" v-b-modal.addWorkflowModal><i
						class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új utasítás</button>
			</div>
		</div>
		<b-modal id="addWorkflowModal" cancel-variant="default" @cancel="closeAddModal()" @ok="addWorkflow"
			ok-title="Létrehozás" cancel-title="Mégse" :ok-disabled="loading"
			@shown="$refs.add_workflow_modal_name_input.focus()">
			<template slot="modal-header">
				<h4 class="modal-title">Új utasítás</h4>
				<a class="btn-close" @click="closeAddModal()"></a>
			</template>
			<form @submit.prevent="addWorkflow()" ref="workflow_modal_form" v-if="loading == false">
				<div class="form-group">
					<label class="form-label">Megnevezés:</label>
					<input ref="add_workflow_modal_name_input" class="form-control text-center"
						:class="{ 'is-invalid': errors.name }" type="text" v-model="workflow.name" required>
					<div v-if="errors.name" class="invalid-feedback d-block">{{ errors.name[0] }}</div>
				</div>
				<div class="form-group">
					<label class="form-label">Leírás:</label>
					<textarea cols="30" rows="10" class="form-control" :class="{ 'is-invalid': errors.description }"
						v-model="workflow.description" required></textarea>
					<div v-if="errors.description" class="invalid-feedback d-block">{{ errors.description[0] }}</div>
				</div>
				<button class="d-none"></button>
			</form>
			<Loading v-else title="Létrehozás"></Loading>
		</b-modal>
		<panel title="Utasítások">
			<Loading v-if="workflows === false" title="Utasítások betöltése"></Loading>
			<NoRecords v-if="workflows.length == 0" main_icon="fas fa-project-diagram" value="false"
				title="Nincsenek utasítások" subtitle="hozzon létre újat"></NoRecords>
			<vue-good-table v-if="workflows.length != 0 && workflows !== false" :columns="columns" :rows="workflows"
				:lineNumbers="true" :search-options="{ enabled: false, placeholder: 'Keresés...' }" :pagination-options="{
				enabled: true,
				position: 'bottom',
				firstLabel: 'Első Lap',
				lastLabel: 'Utolsó Lap',
				nextLabel: 'következő',
				prevLabel: 'előző',
				rowsPerPageLabel: 'Sor oldalanként',
				ofLabel: '/',
				allLabel: 'Összes',
				infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
			}">
				<template slot="table-row" slot-scope="props">
					<span v-if="props.column.field == 'actions'">
						<button @click="copyWorkflow(props.row.id)" class="btn btn-primary" title="másolás"><i
								class="fa fa-copy"></i></button>
						<button @click="deleteWorkflow(props.row.id)" class="btn btn-danger ms-2" title="törlés"><i
								class="fa fa-trash"></i></button>
					</span>
					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
				</template>
			</vue-good-table>
		</panel>
	</div>
</template>

<script>
import Loading from '../../components/Loading';
import NoRecords from '../../components/NoRecords';
import Workflow from "../../apis/Workflow";
import Confirmation from "../../apis/Confirmation";

export default {
	components: {
		Loading, NoRecords
	},
	data() {
		return {
			columns: [
				{
					label: 'Megnevezés',
					field: 'name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés...',
					}
				},
				{
					label: 'Leírás',
					field: 'description',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés...',
					}
				},
				{
					label: 'Létrehozta',
					field: 'creator_name',
					filterOptions: {
						enabled: true,
						placeholder: 'Keresés...',
					}
				},
				{
					label: 'Műveletek',
					field: 'actions',
					width: '15%',
					sortable: false,
					thClass: 'text-end',
					tdClass: 'text-end'
				}
			],
			workflows: false,
			workflow: {},
			errors: [],
			loading: false,
		}
	},
	created() {
		Workflow.index()
			.then(response => {
				this.workflows = response.data;
			});
	},
	methods: {
		closeAddModal() {
			this.workflow = {};
			this.errors = [];
			this.$bvModal.hide('addWorkflowModal')
		},
		addWorkflow(bvModalEvt) {
			this.loading = true;
			if (bvModalEvt) { //ok gombra van csak event
				bvModalEvt.preventDefault();
			}
			Workflow.add(this.workflow)
				.then(response => {
					this.workflows.unshift(response.data);
					this.errors = [];
					this.closeAddModal();
				}).catch(error => {
					if (error.response.data.errors) {
						this.errors = error.response.data.errors;
					}
				}).finally(() => {
					this.loading = false;
				})
		},
		copyWorkflow(id) {
			Confirmation.swalCustomConfirm('Biztos elmásolod az utasítást?', 'Másolás', 'A másolás során az eredeti utasítás törlésre kerül').then(response => {
				this.loading = true;
				if (response.isConfirmed === true) {
					Workflow.copy(id)
						.then(response => {
							this.$router.push({ path: '/workflows/' + response.data.id + '/edit' });
						}).finally(() => {
							this.loading = false;
						});
				}
				else {
					this.loading = false;
				}
			})
		},

		deleteWorkflow(id) {
			Confirmation.swalCustomConfirm('Biztos törlöd az utasítást?', 'Igen').then(response => {
				this.loading = true;
				if (response.isConfirmed === true) {
					Workflow.delete(id)
						.then(() => {
							// Search for the element with the deleted id and remove it from the list
							const index = this.workflows.findIndex(workflow => workflow.id === id);
							if (index !== -1) {
								this.workflows.splice(index, 1);
							}
						})
						.finally(() => {
							this.loading = false;
						});
				} else {
					this.loading = false;
				}
			});
		}
	}
}
</script>

<style></style>